import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { KeycloakInstance } from 'keycloak-js';
import { LumiloginService } from '../service/lumilogin.service';
import { LUMILOGIN_URL, LUMILOGIN_REALM, APPLICATION_NAME, SHOW_SEARCH_BAR, SHOW_LANG_SELECTOR } from '../lumilogin.token';
import { applications } from '../metadata';
import { TranslationLoaderService } from '../service/translation-loader.service';
import {
	trigger,
	style,
	animate,
	transition,
} from '@angular/animations';
import { Subject, Observable } from 'rxjs';
import { NavigationService } from '../navigation/navigation.service';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	animations: [
		trigger('searchBar', [
			transition(':enter', [
				style({
					width: 0
				}),
				animate('500ms', style({
					width: '*'
				}))
			]),
			transition(':leave', [
				animate('500ms', style({
					opacity: 0
				}))
			])
		]),
		trigger('searchIcon', [
			transition(':enter', [
				style({ opacity: 0 }),
				animate('500ms', style({
					opacity: 1
				}))
			]),
			transition(':leave', [
				animate('500ms', style({
					opacity: 0
				}))
			])
		]),
	]
})

export class HeaderComponent implements OnInit {
	public readonly LOGO_PATH = "assets/img/logos/";

	public lumiloginAuth: KeycloakInstance;
	private static url = '';
	private static realm = '';
	public applications;
	public name;
	public brandedLumi = true;
	public appNameBasic;

	public showSearchBarAll: boolean = true;
	public showLangSelector: boolean = true;

	public showSearchBar: boolean = false;
	public searchString: string;
	public searchSubject: Subject<string>;
	public searchObservable: Observable<string>;
	@ViewChild('SearchBar') searchBar: ElementRef;

	public logo_img = '';

	constructor(private lumilogin: LumiloginService,
		@Inject(LUMILOGIN_URL) private url: string,
		@Inject(LUMILOGIN_REALM) private realm: string,
		@Inject(APPLICATION_NAME) private applicationName: string,
		@Inject(SHOW_SEARCH_BAR) private show_Search_Bar_All: boolean,
		@Inject(SHOW_LANG_SELECTOR) private show_Lang_Selector: boolean,
		public _translationLoaderService: TranslationLoaderService,
		public navigationService: NavigationService
	) {
		HeaderComponent.url = url;
		HeaderComponent.realm = realm;
		this.appNameBasic = applicationName;
		this.name = this.displayAppName(applicationName);

		this.showSearchBarAll = show_Search_Bar_All;
		this.showLangSelector = show_Lang_Selector;

		this.searchSubject = new Subject<string>();
		this.searchObservable = this.searchSubject.asObservable();
		this.lumilogin.searchObservable = this.searchObservable;

		const element = document.createElement('link');
		element.rel = 'stylesheet';
		const pageUrl: string = document.location.href.toLowerCase();
		if (pageUrl.includes("lumiplay")) {
			element.href = 'city.css';
			this.logo_img = 'lumiplay.png';
		} else if (pageUrl.includes("mountainlive")) {
			element.href = 'mountain.css';
			this.logo_img = 'mountain-live.png';
		} else {
			element.href = 'group.css';
			this.logo_img = 'lumiplan.png';
		}
		document.body.appendChild(element);
	}

	ngOnInit() {
		this.lumiloginAuth = this.lumilogin.getKeycloakAuth();
		this.applications = applications;
	}

	login() {
		this.lumilogin.login();
	}

	logout() {
		this.lumilogin.logout();
	}

	displayUserInfo() {
		return this.lumilogin.getFullName();
	}

	getCompanyName() {
		return this.lumilogin.getCompanyName() === '' ? '-' : this.lumilogin.getCompanyName();
	}

	getAccountUrl() {
		return HeaderComponent.url + 'realms/' + HeaderComponent.realm + '/account';
	}

	initialName() {
		if (this.lumilogin.getFullName() === undefined) {
			return '';
		} else {
			return this.lumilogin.getFullName().split(' ').map(s => s[0]).join('');
		}
	}

	isLoggedIn() {
		return this.lumilogin.isLoggedIn();
	}

	displayAppName(name: string) {
		let nameApp = 'BackOffice';
		applications.forEach(app => {
			if (app.name.toLowerCase() === name.toLowerCase()) {
				this.brandedLumi = app.name.indexOf('Lumi') !== -1;
				nameApp = app.name.replace('Lumi', '');
			}
		});
		return nameApp;
	}

	showAppMenu() {
		const arr = this.filterApplications();

		if (arr.length === 0) { return false; }

		return !(arr.length <= 1 && arr[0].name.toLowerCase() === this.appNameBasic.toLowerCase());
	}

	filterApplications() {
		return applications.filter(app => {
			return this.lumilogin.getApplications().includes(app.name.toLowerCase());
		});
	}

	setLanguage(lang): void {
		this._translationLoaderService.setLanguage(lang);
	}

	onSearchBarChange(): void {
		this.searchSubject.next(this.searchString)
	}

	onClickCloseSearchBar(): void {
		this.showSearchBar = false;
		this.searchString = "";
		this.searchSubject.next(this.searchString);
	}

	onToggleSearchBarClick() {
		this.showSearchBar = !this.showSearchBar;
		if (this.searchBar)
			this.searchBar.nativeElement.focus();
	}
}
